module.exports = __webpack_public_path__ + "media/images/icons/plus-circle-625e45882c10d6d2dd626b3ea71dcd14.svg";